import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { request, withRetry } from 'src/commons/utils/async-request';

// FIT CSRF token, decoupled from the full navState payload.
const url = '/ccx/ajax/getCsrfToken';

const requestWithRetry = withRetry<
  AxiosRequestConfig,
  Promise<AxiosResponse<{ csrfToken: string }>>
>(async (config) => {
  return request<{ csrfToken: string }>(config);
});

// Throws when the token is absent so the failure is logged at fetch time,
// rather than silently proceeding to a POST that will fail CSRF anyway.
export default async (): Promise<string> => {
  const response = await requestWithRetry({ url });
  const csrfToken = response.data?.csrfToken;
  if (typeof csrfToken !== 'string' || csrfToken === '') {
    throw new Error('getCsrfToken: response missing csrfToken');
  }
  return csrfToken;
};
